import { render, staticRenderFns } from "./main-results-panel.vue?vue&type=template&id=4ec059ef&"
import script from "./main-results-panel.vue?vue&type=script&lang=ts&"
export * from "./main-results-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec059ef')) {
      api.createRecord('4ec059ef', component.options)
    } else {
      api.reload('4ec059ef', component.options)
    }
    module.hot.accept("./main-results-panel.vue?vue&type=template&id=4ec059ef&", function () {
      api.rerender('4ec059ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/_main-results-panel/main-results-panel.vue"
export default component.exports